import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import { notification } from 'antd';

import { useParams } from "react-router";

import Tools from '../../components/util/tools';
import Equipment from './Equipment';
import Tab from '../../components/Tab/local';

import SvgIcon from '@material-ui/core/SvgIcon';
import styled from "styled-components";

import emb200Preview from '../../assets/replay_3d/models/emb-200/aeronave.png';
import emb203Preview from '../../assets/replay_3d/models/emb-203/aeronave.png';
import airTractorAt502bPreview from '../../assets/replay_3d/models/air-tractor-at-502b/aeronave.png';
import airTractorAt802Preview from '../../assets/replay_3d/models/air-tractor-at-802/aeronave.png';
import cessna188Preview from '../../assets/replay_3d/models/cessna-188/aeronave.png';
import thrush510Preview from '../../assets/replay_3d/models/thrush-510/aeronave.png';

import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import Units from '../../components/util/units';
const Container = styled.span`
  display: inline-flex;
  align-items: center;
  width: 150px;
  max-width: 150px;
  padding: 4px 12px;
  border: 1px solid #bfc9d9;
  border-radius: 4px;
  margin-top: 50px;

  input[type="color"] {
    margin-right: 8px;
    -webkit-appearance: none;
    border: none;
    width: auto;
    height: auto;
    cursor: pointer;
    background: none;
    &::-webkit-color-swatch-wrapper {
      padding: 0;
      width: 14px;
      height: 14px;
    }
    &::-webkit-color-swatch {
      border: 1px solid #bfc9d9;
      border-radius: 4px;
      padding: 0;
    }
  }

  input[type="text"] {
    border: none;
    width: 100%;
    font-size: 14px;
  }
`;

const ColorPicker = props => {
  return (
    <Container>
      <input type="color" {...props} />
      <input type="text" {...props} />
    </Container>
  );
};

const replay3DModelOptions = [
  {
    id: 'air-tractor-at-502b',
    label: 'Air Tractor AT-502B',
    previewUrl: airTractorAt502bPreview
  },
  {
    id: 'air-tractor-at-802',
    label: 'Air Tractor AT-802',
    previewUrl: airTractorAt802Preview
  },
  {
    id: 'cessna-188',
    label: 'Cessna 188 AG',
    previewUrl: cessna188Preview
  },
  {
    id: 'emb200',
    label: 'EMB-200 Ipanema',
    previewUrl: emb200Preview
  },
  {
    id: 'emb-203',
    label: 'EMB-203 Ipanema',
    previewUrl: emb203Preview
  },
  {
    id: 'thrush-510',
    label: 'Thrush 510',
    previewUrl: thrush510Preview
  }
];

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {
  state = {
    stage: '0',

    id: this.props.id,
    id_aircraftbrand: '',
    id_aircraftmodel: '',
    replay3DModel: '0',
    replay3DPreviewModel: '0',
    aircraftbrands: [],
    aircraftmodels: [],
    id_dgps: '0',
    list_dgps: [],
    name: '',
    serial: '',
    manufactured: '',
    cva_expiration: '',
    reta_expiration: '',
    hull_expiration: '',
    application_speed: '',
    travel_speed: '',
    balloon_speed: '',
    flow_rate: '',
    hopper_load: '',
    swath_width: '',
    flight_height: '',
    balloon_width: '',
    balloon_length: '',

    aircraftColorCustomized: false,

    aircraftColors: {
      special: '',
      specialColor: '#000000',
      showBackground: '1',
      border: '#666666',
      background: '#FFFFFF',
      wings: '#000000',
      wingsDetail: '#000000',
      wingsDetail2: '#000000',
      wingsDetail3: '#000000',
      front: '#000000',
      frontDetail: '#000000',
      propeller: '#000000',
      back: '#000000',
      hoper: '#000000',
      hoperDetail: '#000000',
      windowsType: '1',
      windowsColor: '#000000',
      windowsColor2: '#000000',
      middle: '#000000',
      tailType: '1',
      tailColor: '#000000',
      tailColor2: '#000000'
    },

    backClikCount: 0,
    wingClickCount: 0,

    itensAutoConfig: [],
    perfis_auto: []
  };

  componentDidMount() {
    this.loadPerfisAuto();
    if (this.state.id) {
      const apiUrl = Config.server + '/plane/' + this.state.id;

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.length > 0) {
              this.setState({
                name: result[0].name,
                id_aircraftbrand: result[0].id_aircraftbrand ? result[0].id_aircraftbrand : '0',
                id_aircraftmodel: result[0].id_aircraftmodel ? result[0].id_aircraftmodel : '0',
                replay3DModel: result[0].model3D ? result[0].model3D : '0',
                replay3DPreviewModel: result[0].model3D ? result[0].model3D : '0',
                id_dgps: result[0].id_dgps ? result[0].id_dgps : '0',
                serial: result[0].serial,
                manufactured: result[0].manufactured ? Tools.getDateToInputDate(result[0].manufactured) : null,
                cva_expiration: result[0].cva_expiration ? Tools.getDateToInputDate(result[0].cva_expiration) : null,
                reta_expiration: result[0].reta_expiration ? Tools.getDateToInputDate(result[0].reta_expiration) : null,
                hull_expiration: result[0].hull_expiration ? Tools.getDateToInputDate(result[0].hull_expiration) : null,
                application_speed: result[0].application_speed ? Units.convertSpeed(result[0].application_speed, 'km/h', this.props.res) : '',
                travel_speed: result[0].travel_speed ? Units.convertSpeed(result[0].travel_speed, 'km/h', this.props.res) : '',
                balloon_speed: result[0].balloon_speed ? Units.convertSpeed(result[0].balloon_speed, 'km/h', this.props.res) : '',
                flow_rate: result[0].flow_rate ? Units.convertFlow(result[0].flow_rate, 'L', 'ha', this.props.res) : '',
                hopper_load: result[0].hopper_load ? Units.convertVolume(result[0].hopper_load, 'L', this.props.res) : '',
                swath_width: result[0].swath_width ? Units.convertLength(result[0].swath_width, 'm', this.props.res) : '',
                flight_height: result[0].flight_height ? Units.convertLength(result[0].flight_height, 'm', this.props.res) : '',
                balloon_width: result[0].balloon_width ? Units.convertLength(result[0].balloon_width, 'm', this.props.res) : '',
                balloon_length: result[0].balloon_length ? Units.convertLength(result[0].balloon_length, 'm', this.props.res) : '',
                aircraftColors: result[0].svg ? JSON.parse(result[0].svg) : this.state.aircraftColors,
                aircraftColorCustomized: result[0].svg ? true : false
              });

              if (result[0].id_aircraftbrand) {
                this.loadAircraftModels(result[0].id_aircraftbrand);
                if (result[0].svg && result[0].svg.length > 0) {
                  this.updateColors(JSON.parse(result[0].svg));
                } else {
                  this.updateColorsByModel(this.state.id_aircraftmodel);
                }
              }
            }
          },
          (error) => {
            if (error.status === 401) {
              this.props.link('/login');
            }
            else {
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
    this.loadAircraftBrands();
    this.loadListDgps();
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  getReplay3DModelOption = (value) => {
    return replay3DModelOptions.find(item => item.id === value) || null;
  };

  getReplay3DPreviewOption = () => {
    return this.getReplay3DModelOption(this.state.replay3DPreviewModel) ||
      this.getReplay3DModelOption(this.state.replay3DModel);
  };

  handleReplay3DModelChange = event => {
    const value = event.target.value;

    this.setState({
      replay3DModel: value,
      replay3DPreviewModel: value
    });
  };

  loadAircraftBrands = () => {
    const apiUrl = Config.server + '/domain/AIRCRAFTBRAND';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            aircraftbrands: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  loadListDgps = () => {
    const apiUrl = Config.server + '/dgps_select';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            list_dgps: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  loadAircraftModels = (id_aircraftbrand) => {
    const apiUrl = `${Config.server}/domain/AIRCRAFTMODEL/${id_aircraftbrand}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            aircraftmodels: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  loadPerfisAuto = () => {
    const apiUrl = Config.server + '/profile_auto';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            perfis_auto: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleNumberChange = name => event => {
    let value = event.target.value.replace(/[^0-9,]/g, '');
    let parts = value.split(',');

    if (parts.length > 2) {
      value = parts[0] + ',' + parts.slice(1).join('');
    }

    this.setState({
      [name]: value,
    });
  };

  handleAircraftBrandChange = event => {
    this.setState({
      id_aircraftbrand: event.target.value,
      id_aircraftmodel: '0'
    });
    if (event.target.value) {
      this.loadAircraftModels(event.target.value);
    }
  };

  updateColorsByModel = (value) => {
    if (this.state.id_aircraftbrand == 5) {
      this.setState({
        aircraftColors: {
          special: '',
          specialColor: '#000000',
          showBackground: '2',
          border: '#666666',
          background: '#FFFFFF',
          wings: '#FEC629',
          wingsDetail: '#026EC8',
          wingsDetail2: '#000000',
          wingsDetail3: '#000000',
          front: '#FEC629',
          frontDetail: '#000000',
          propeller: '#000000',
          back: '#FEC629',
          hoper: '#7E8B91',
          hoperDetail: '#000000',
          windowsType: '2',
          windowsColor: '#BDBFC1',
          windowsColor2: '#F4F5F6',
          middle: '#FEC629',
          tailType: '2',
          tailColor: '#000000',
          tailColor2: '#026EC8'
        }, id_aircraftmodel: value
      });
    } else if (this.state.id_aircraftbrand == 4) {
      this.setState({
        aircraftColors: {
          special: '',
          specialColor: '#000000',
          showBackground: '2',
          border: '#666666',
          background: '#FFFFFF',
          wings: '#F0F0F0',
          wingsDetail: '#C33538',
          wingsDetail2: '#000000',
          wingsDetail3: '#000000',
          front: '#F0F0F0',
          frontDetail: '#000000',
          propeller: '#F0F0F0',
          back: '#F0F0F0',
          hoper: '#7E8B91',
          hoperDetail: '#000000',
          windowsType: '2',
          windowsColor: '#BDBFC1',
          windowsColor2: '#F4F5F6',
          middle: '#F0F0F0',
          tailType: '2',
          tailColor: '#000000',
          tailColor2: '#C33538'
        }, id_aircraftmodel: value
      });
    } else if (value == 46) {
      this.setState({
        aircraftColors: {
          special: '',
          specialColor: '#000000',
          showBackground: '2',
          border: '#666666',
          background: '#FFFFFF',
          wings: '#1547AB',
          wingsDetail: '#1547AB',
          wingsDetail2: '#000000',
          wingsDetail3: '#1547AB',
          front: '#009116',
          frontDetail: '#009116',
          propeller: '#E6E7E8',
          back: '#1547AB',
          hoper: '#A9ABAE',
          hoperDetail: '#000000',
          windowsType: '1',
          windowsColor: '#BDBFC1',
          windowsColor2: '#F4F5F6',
          middle: '#FFC014',
          tailType: '1',
          tailColor: '#009116',
          tailColor2: '#FFC014'
        }, id_aircraftmodel: value
      });
    } else {
      this.setState({
        id_aircraftmodel: value
      });
    }
  };

  updateColors = (value) => {
    this.setState({ aircraftColors: value });
  };

  handleAircraftModelChange = event => {
    const value = event.target.value;
    this.updateColorsByModel(value);
  };

  handleColorChange = name => event => {
    const colors = this.state.aircraftColors;
    colors[name] = event.target.value;
    this.setState({
      aircraftColorCustomized: true,
      aircraftColors: colors
    });
  };

  handleBackClick = event => {
    let count = this.state.backClikCount;
    count++;
    if (count == 3) {
      this.setState({
        aircraftColors: {
          special: 'travicar',
          specialColor: '#000000',
          showBackground: '2',
          border: '#FFFFFF',
          background: '#000000',
          wings: '#FF6600',
          wingsDetail: '#FF6600',
          wingsDetail2: '#FF6600',
          wingsDetail3: '#FF6600',
          front: '#FF6600',
          frontDetail: '#FF6600',
          propeller: '#FF6600',
          back: '#FF6600',
          hoper: '#FF6600',
          hoperDetail: '#FF6600',
          windowsType: '3',
          windowsColor: '#BDBFC1',
          windowsColor2: '#F4F5F6',
          middle: '#FF6600',
          tailType: '2',
          tailColor: '#FF6600',
          tailColor2: '#FF6600'
        }
      });
    }

    this.setState({ backClikCount: count });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    let apiUrl = Config.server + '/plane';
    let method = '';

    const formData = new URLSearchParams();
    if (this.state.id) {
      apiUrl += '/' + this.state.id;
      formData.append('id', this.state.id);
      method = 'PUT';
    } else {
      method = 'POST';
    }
    if (this.state.id_aircraftbrand !== '0') {
      formData.append('id_aircraftbrand', this.state.id_aircraftbrand);
    } else {
      notification.open({
        message: 'Selecione um Fabricante',
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }
    if (this.state.id_aircraftmodel !== '0') {
      formData.append('id_aircraftmodel', this.state.id_aircraftmodel);
    } else {
      notification.open({
        message: 'Selecione um Modelo',
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    formData.append('name', this.state.name);
    formData.append('model3D', this.state.replay3DModel !== '0' ? this.state.replay3DModel : '');

    if (this.state.id_dgps !== '0') {
      formData.append('id_dgps', this.state.id_dgps);
    }

    if (this.state.serial && this.state.serial.length) {
      formData.append('serial', this.state.serial);
    }

    if (this.state.manufactured && this.state.manufactured.length) {
      formData.append('manufactured', this.state.manufactured);
    }

    if (this.state.cva_expiration && this.state.cva_expiration.length) {
      formData.append('cva_expiration', this.state.cva_expiration);
    }

    if (this.state.reta_expiration && this.state.reta_expiration.length) {
      formData.append('reta_expiration', this.state.reta_expiration);
    }

    if (this.state.hull_expiration && this.state.hull_expiration.length) {
      formData.append('hull_expiration', this.state.hull_expiration);
    }

    formData.append('application_speed', this.state.application_speed === '' ? '' : Units.toCanonicalSpeed(this.state.application_speed, this.props.res));
    formData.append('travel_speed', this.state.travel_speed === '' ? '' : Units.toCanonicalSpeed(this.state.travel_speed, this.props.res));
    formData.append('balloon_speed', this.state.balloon_speed === '' ? '' : Units.toCanonicalSpeed(this.state.balloon_speed, this.props.res));
    formData.append('flow_rate', this.state.flow_rate === '' ? '' : Units.toCanonicalFlow(this.state.flow_rate, this.props.res, 'L', 'ha'));
    formData.append('hopper_load', this.state.hopper_load === '' ? '' : Units.toCanonicalVolume(this.state.hopper_load, this.props.res));
    formData.append('swath_width', this.state.swath_width === '' ? '' : Units.toCanonicalLength(this.state.swath_width, this.props.res));
    formData.append('flight_height', this.state.flight_height === '' ? '' : Units.toCanonicalLength(this.state.flight_height, this.props.res));
    formData.append('balloon_width', this.state.balloon_width === '' ? '' : Units.toCanonicalLength(this.state.balloon_width, this.props.res));
    formData.append('balloon_length', this.state.balloon_length === '' ? '' : Units.toCanonicalLength(this.state.balloon_length, this.props.res));

    formData.append('svg', JSON.stringify(this.state.aircraftColors));

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          let msg = this.props.res.ITEM_INCLUIR;
          if (this.state.id) {
            msg = this.props.res.ITEM_ALTERADO;
          }
          notification.open({
            message: this.props.res.SUCESSO,
            description: msg,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          if (!this.state.id) {
            this.setState({
              id: result
            });
            this.props.link('/app/cadastro/aeronave/edit/' + result);
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  handleChangeTab = name => (event, newValue) => {
    let value = newValue ? newValue : event.target.value;
    this.setState({
      [name]: value,
    });
  };

  newAutoConfig = () => {
    return {
      id_profile: '0',
      filters: [
        {
          active: false,
          type: 'largura',
          set_min: 15,
          set_max: 25,
        },
        {
          active: false,
          type: 'fluxo',
          set_min: 5,
          set_max: 15,
        },
        {
          active: false,
          type: 'altura',
          set_min: 1,
          set_max: 5,
        },
        {
          active: false,
          type: 'velocidade',
          set_min: 150,
          set_max: 230,
        }
      ]
    };
  };

  handleChangeFilters = (item, type, field) => event => {
    let filter = item.filters.find(item => (item.type === type));
    if (!filter) {
      filter = this.newAutoConfig();
      item.filters.push(filter);
    }
    if (field === 'active') {
      filter[field] = !filter['active'];
    } else {
      let value = Number(event.target.value);
      if (type === 'largura' || type === 'altura') value = Units.toCanonicalLength(value, this.props.res);
      else if (type === 'fluxo') value = Units.toCanonicalFlow(value, this.props.res, 'L', 'ha');
      else if (type === 'velocidade') value = Units.toCanonicalSpeed(value, this.props.res);
      filter[field] = value;
    }
    this.setState({ itensAutoConfig: this.state.itensAutoConfig });
  };
  handlePerfilChange = (item) => event => {
    item.id_profile = event.target.value;
    this.setState({ itensAutoConfig: this.state.itensAutoConfig });
  };

  autoConfig = (item) => {
    let defaultValue = this.newAutoConfig();
    let defaultFilters = defaultValue.filters;
    let largura = item.filters.find(item => (item.type === 'largura'));
    let fluxo = item.filters.find(item => (item.type === 'fluxo'));
    let altura = item.filters.find(item => (item.type === 'altura'));
    let velocidade = item.filters.find(item => (item.type === 'velocidade'));
    let defaultLargura = defaultFilters.find(item => (item.type === 'largura'));
    let defaultFluxo = defaultFilters.find(item => (item.type === 'fluxo'));
    let defaultAltura = defaultFilters.find(item => (item.type === 'altura'));
    let defaultVelocidade = defaultFilters.find(item => (item.type === 'velocidade'));

    return <div style={{ margin: '1rem', borderTop: 'solid 1px #d1d1d1' }}>
      <div style={{ display: 'flex' }}>
        <h4>{this.props.res.FILTRO}</h4>
        <div style={{ width: '12rem', position: 'relative', margin: '1rem' }}>
          <h4>{this.props.res.LARGURA_FAIXA} ({Units.getLengthUnit(this.props.res)})</h4>
          <Checkbox
            disableRipple
            checked={largura && largura.active}
            onClick={this.handleChangeFilters(item, 'largura', 'active')}
            style={{ position: 'absolute', right: '.5rem', top: '0' }}
          />
          <TextField
            disabled={!largura || !largura.active}
            label={this.props.res.MINIMO}
            value={Units.convertLength((largura ? largura : defaultLargura).set_min, 'm', this.props.res)}
            onChange={this.handleChangeFilters(item, 'largura', 'set_min')}
            type="number"
          />
          <TextField
            disabled={!largura || !largura.active}
            label={this.props.res.MAXIMO}
            value={Units.convertLength((largura ? largura : defaultLargura).set_max, 'm', this.props.res)}
            onChange={this.handleChangeFilters(item, 'largura', 'set_max')}
            type="number"
          />
        </div>
        <div style={{ width: '12rem', position: 'relative', margin: '1rem' }}>
          <h4>{this.props.res.FLUXO_APLICACAO} ({Units.getFlowUnit(this.props.res, 'L')})</h4>
          <Checkbox
            disableRipple
            checked={fluxo && fluxo.active}
            onClick={this.handleChangeFilters(item, 'fluxo', 'active')}
            style={{ position: 'absolute', right: '.5rem', top: '0' }}
          />
          <TextField
            disabled={!fluxo || !fluxo.active}
            label={this.props.res.MINIMO}
            value={Units.convertFlow((fluxo ? fluxo : defaultFluxo).set_min, 'L', 'ha', this.props.res)}
            onChange={this.handleChangeFilters(item, 'fluxo', 'set_min')}
            type="number"
          />
          <TextField
            disabled={!fluxo || !fluxo.active}
            label={this.props.res.MAXIMO}
            value={Units.convertFlow((fluxo ? fluxo : defaultFluxo).set_max, 'L', 'ha', this.props.res)}
            onChange={this.handleChangeFilters(item, 'fluxo', 'set_max')}
            type="number"
          />
        </div>
        <div style={{ width: '12rem', position: 'relative', margin: '1rem' }}>
          <h4>{this.props.res.ALTURA_VOO} ({Units.getLengthUnit(this.props.res)})</h4>
          <Checkbox
            disableRipple
            checked={altura && altura.active}
            onClick={this.handleChangeFilters(item, 'altura', 'active')}
            style={{ position: 'absolute', right: '.5rem', top: '0' }}
          />
          <TextField
            disabled={!altura || !altura.active}
            label={this.props.res.MINIMO}
            value={Units.convertLength((altura ? altura : defaultAltura).set_min, 'm', this.props.res)}
            onChange={this.handleChangeFilters(item, 'altura', 'set_min')}
            type="number"
          />
          <TextField
            disabled={!altura || !altura.active}
            label={this.props.res.MAXIMO}
            value={Units.convertLength((altura ? altura : defaultAltura).set_max, 'm', this.props.res)}
            onChange={this.handleChangeFilters(item, 'altura', 'set_max')}
            type="number"
          />
        </div>
        <div style={{ width: '12rem', position: 'relative', margin: '1rem' }}>
          <h4>{this.props.res.VELOCIDADE_TITLE}</h4>
          <Checkbox
            disableRipple
            checked={velocidade && velocidade.active}
            onClick={this.handleChangeFilters(item, 'velocidade', 'active')}
            style={{ position: 'absolute', right: '.5rem', top: '0' }}
          />
          <TextField
            disabled={!velocidade || !velocidade.active}
            label={this.props.res.MINIMO}
            value={Units.convertSpeed((velocidade ? velocidade : defaultVelocidade).set_min, 'km/h', this.props.res)}
            onChange={this.handleChangeFilters(item, 'velocidade', 'set_min')}
            type="number"
          />
          <TextField
            disabled={!velocidade || !velocidade.active}
            label={this.props.res.MAXIMO}
            value={Units.convertSpeed((velocidade ? velocidade : defaultVelocidade).set_max, 'km/h', this.props.res)}
            onChange={this.handleChangeFilters(item, 'velocidade', 'set_max')}
            type="number"
          />
        </div>
      </div>
      <FormControl style={{ width: '100%', maxWidth: '40rem' }}>
        <InputLabel htmlFor="aircraftbrand">{this.props.res.PERFIL}</InputLabel>
        <Select
          style={{ textAlign: 'left' }}
          id='aircraftbrand'
          value={item.id_profile}
          onChange={this.handlePerfilChange(item)}
          inputProps={{
            id: 'id_aircraftbrand',
          }}
        >
          <MenuItem key={'0id_aircraftbrand'} value={'0'}>{this.props.res.SELECIONE}</MenuItem>
          {this.state.perfis_auto.map((n, key) => {
            return (
              <MenuItem key={key} value={n.id}>{n.name}</MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  }

  render() {
    const { link, res } = this.props;

    const tabMenuItens = [
      { label: res.INFORMACAO, value: '0', active: true },
      { label: res.AVATAR, value: '2', active: true },
      { label: res.EQUIPAMENTO, value: '1', active: this.state.id ? true : false },
      { label: res.CONFIGURACOES ? res.CONFIGURACOES : 'Configurações', value: '3', active: true },
      { label: res.REGRA_QUALIDADE ? res.REGRA_QUALIDADE : 'Regra de Qualidade', value: '4', active: true },
    ];
    const replay3DPreviewOption = this.getReplay3DPreviewOption();

    return (
      <div>
        <div className="divContent" style={{ marginBottom: '1rem', height: '5rem' }}>
          <form onSubmit={this.handleSubmit}>
            <div className="containerTop">
              <div><h1>{res.AERONAVE}</h1></div>
              <div className="centerTop"></div>
              <div>
                <Button variant="contained" onClick={() => { link('/app/cadastro/aeronave/list') }} className="popUpButton">
                  {res.CANCELAR}
                </Button> &nbsp;
                <Button type="submit" variant="contained" color="primary" className="popUpButton">
                  <SaveIcon className="iconMapS" />
                  {res.SALVAR}
                </Button>
              </div>
            </div>
          </form>
        </div>
        <div className="divContent" style={{ marginBottom: '1rem' }}>
          <div style={{ width: '40rem', height: '3rem' }}>
            <Tab value={this.state.stage} handleChange={this.handleChangeTab} name="stage" itens={tabMenuItens} />
          </div>
          <div style={{ display: this.state.stage === '0' ? 'block' : 'none' }} >
            <div className="form-group notTooBig">
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor="aircraftbrand">{res.FABRICANTE}</InputLabel>
                <Select
                  style={{ textAlign: 'left' }}
                  id='aircraftbrand'
                  value={this.state.id_aircraftbrand}
                  onChange={this.handleAircraftBrandChange}
                  inputProps={{
                    id: 'id_aircraftbrand',
                  }}
                >
                  <MenuItem key={'0id_aircraftbrand'} value={'0'}>{this.props.res.SELECIONE}</MenuItem>
                  {this.state.aircraftbrands.map((n, key) => {
                    return (
                      <MenuItem key={key} value={n.id}>{n.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl style={{ width: '100%', marginTop: '1rem' }}>
                <InputLabel htmlFor="aircraftmodel">{res.MODELO}</InputLabel>
                <Select
                  style={{ textAlign: 'left' }}
                  id='aircraftmodel'
                  value={this.state.id_aircraftmodel}
                  onChange={this.handleAircraftModelChange}
                  inputProps={{
                    id: 'id_aircraftmodel',
                  }}
                >
                  <MenuItem key={'0aircraftmodel'} value={'0'}>{'Selecione'}</MenuItem>
                  {this.state.aircraftmodels.map((n, key) => {
                    return (
                      <MenuItem key={key} value={n.id}>{n.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <div style={{ marginTop: '1rem' }}>
                <FormControl style={{ width: '100%' }}>
                  <InputLabel htmlFor="replay3DModel">{res.MODELO_AERONAVE_3D}</InputLabel>
                  <Select
                    style={{ textAlign: 'left' }}
                    id="replay3DModel"
                    value={this.state.replay3DModel}
                    onChange={this.handleReplay3DModelChange}
                    inputProps={{
                      id: 'replay3DModel'
                    }}
                  >
                    <MenuItem key="0replay3DModel" value="0">{res.SELECIONE}</MenuItem>
                    {replay3DModelOptions.map((item) => {
                      return (
                        <MenuItem
                          key={item.id}
                          value={item.id}
                        >
                          {item.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {!replay3DPreviewOption ?
                  <div style={{
                    marginTop: '1rem',
                    padding: '1rem',
                    border: '1px dashed #bfc9d9',
                    borderRadius: '6px',
                    color: '#6b7280',
                    textAlign: 'center',
                    background: '#fafafa'
                  }}>
                    {res.SELECIONE_MODELO_3D_VISUALIZAR}
                  </div>
                  :
                  <div style={{ marginTop: '1rem' }}>
                    <div style={{
                      fontSize: '0.85rem',
                      color: '#6b7280',
                      marginBottom: '0.35rem'
                    }}>
                      {res.PRE_VISUALIZACAO_MODELO_3D}: {replay3DPreviewOption.label}
                    </div>
                    <div style={{
                      width: '100%',
                      height: '300px',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      background: 'linear-gradient(180deg, #ffffff 0%, #f3f4f6 100%)',
                      overflow: 'hidden'
                    }}>
                      <img
                        src={replay3DPreviewOption.previewUrl}
                        alt={replay3DPreviewOption.label}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          display: 'block',
                          padding: '1rem',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>
                  </div>}
              </div>
              <TextField
                id="name"
                label={res.PREFIXO}
                value={this.state.name}
                onChange={this.handleChange('name')}
                margin="normal"
                fullWidth
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
              <TextField
                id="serial"
                label={res.SERIE}
                value={this.state.serial}
                onChange={this.handleChange('serial')}
                margin="normal"
                fullWidth
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
              <FormControl style={{ width: '100%', marginTop: '1rem' }}>
                <TextField
                  id="manufactured"
                  type="date"
                  label={res.ANOFABRICACAO}
                  value={this.state.manufactured}
                  onChange={this.handleChange('manufactured')}
                  style={{ width: '11rem', marginBottom: '1rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  id="cva_expiration"
                  type="date"
                  label={res.VALIDADECVA}
                  value={this.state.cva_expiration}
                  onChange={this.handleChange('cva_expiration')}
                  style={{ width: '11rem', marginBottom: '1rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  id="reta_expiration"
                  type="date"
                  label={res.VALIDADERETA}
                  value={this.state.reta_expiration}
                  onChange={this.handleChange('reta_expiration')}
                  style={{ width: '11rem', marginBottom: '1rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <TextField
                  id="hull_expiration"
                  type="date"
                  label={res.VALIDADECASCO}
                  value={this.state.hull_expiration}
                  onChange={this.handleChange('hull_expiration')}
                  style={{ width: '11rem', marginBottom: '1rem' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor="dgps">{res.DGPS}</InputLabel>
                <Select
                  style={{ textAlign: 'left' }}
                  id='dgps'
                  value={this.state.id_dgps}
                  onChange={this.handleChange('id_dgps')}
                  inputProps={{
                    id: 'id_dgps',
                  }}
                >
                  <MenuItem key={'00'} value={'0'}>{res.SELECIONE}</MenuItem>
                  {this.state.list_dgps.map((n, key) => {
                    return (
                      <MenuItem key={key} value={n.id}>{n.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
          <div style={{ display: this.state.stage === '1' ? 'block' : 'none' }}>
            <Equipment res={res} link={link} />
          </div>
          <div style={{ display: this.state.stage === '2' ? 'block' : 'none' }} >
            <div className="form-group notTooBig2">
              <div style={{ width: '100%', marginTop: '20px' }}>
                <FormControl style={{ width: '100%' }}>
                  <SvgIcon id='svg' viewBox="580 0 1000 1600"
                    style={{ color: '#000000', width: '35rem', height: '20rem', marginLeft: 'auto', marginRight: 'auto' }}>
                    <path display={this.state.aircraftColors.showBackground == '2' && 'none'} color={this.state.aircraftColors.background} d="M921.79 423.76l-769.47 0c-89.99,-1.59 -147.49,58.49 -142.52,151.01l16.37 217.02 903.71 0 52.81 366.09 -244.02 0c-50.85,0.91 -97.98,36.57 -87.52,97.53l29.27 140.68 203.46 -0.16 0 28.11 145.18 0 54.71 82.61 55.16 -82.61 144.73 0 -0.01 -28.11 203.47 0.16 29.26 -140.68c10.47,-60.96 -36.66,-96.62 -87.52,-97.53l-244.01 0 52.8 -366.09 903.72 0 16.37 -217.02c4.96,-92.52 -52.53,-152.6 -142.52,-151.01l-769.47 0c-20.22,-203.91 -74.48,-326.49 -161.98,-412.03 -87.51,85.54 -141.77,208.12 -161.98,412.03z" />
                    <path display={this.state.aircraftColors.showBackground == '2' && 'none'} color={this.state.aircraftColors.border} d="M921.79 434.85l-769.58 -0.03c-4.38,-0.07 -8.76,0.01 -13.11,0.24 -36.97,1.98 -67.35,15.39 -88.59,37.73 -21.27,22.36 -33.52,53.84 -34.19,91.92 -0.08,4.45 0.01,9.09 0.26,13.87l17.6 206.39 903.24 0c18.33,121.49 34.93,262.49 53.18,384l-251.93 0c-5.15,0.06 -10.35,0.57 -15.5,1.45 -18.47,3.16 -35.43,11.34 -47.6,23.95 -12.04,12.46 -19.46,29.35 -19.09,50.13 0.08,4.42 0.53,9.1 1.38,14.03l28.18 130.4 204.63 -0.16 0 28.08 142.03 0 51.1 77.16 51.51 -77.16 141.56 0 -0.01 -28.08 204.64 0.16 28.18 -130.4c0.85,-4.93 1.3,-9.61 1.37,-14.03 0.37,-20.78 -7.05,-37.67 -19.08,-50.13 -12.17,-12.6 -29.14,-20.78 -47.6,-23.95 -5.15,-0.88 -10.35,-1.39 -15.51,-1.48l-251.92 0.03 56.53 -384 903.24 0 14.24 -206.39c0.26,-4.78 0.35,-9.42 0.27,-13.88 -0.67,-38.07 -12.93,-69.55 -34.19,-91.92 -21.24,-22.33 -51.62,-35.74 -88.59,-37.73 -4.36,-0.22 -8.74,-0.3 -13.11,-0.23l-775.73 0.03 -0.61 -6.15c-10.04,-101.29 -28.51,-182.31 -55.31,-248.55 -25.66,-63.45 -59,-113.36 -99.91,-154.58 -40.91,41.23 -74.26,91.13 -99.92,154.58 -26.79,66.24 -45.26,147.26 -55.3,248.55l-0.61 6.15 -6.15 0zm-769.47 -13.6l763.33 -0.03c10.31,-99.77 28.87,-180.07 55.59,-246.12 27.41,-67.77 63.38,-120.56 107.79,-163.97l4.73 -4.63 4.75 4.63c44.41,43.41 80.38,96.2 107.79,163.97 26.72,66.05 45.28,146.35 55.58,246.12l763.34 0c4.79,-0.05 9.43,0.03 13.91,0.26 40.59,2.18 74.12,17.09 97.75,41.94 23.59,24.81 37.18,59.43 37.91,101.07 0.09,4.94 0,9.92 -0.27,14.89 0,72.08 -9.89,145.09 -15.14,219.21l-904.19 0 -52.43 356.75 236.21 0.03c6.04,0.1 11.97,0.66 17.69,1.64 21.22,3.64 40.84,13.18 55.1,27.94 14.41,14.92 23.3,35.08 22.87,59.77 -0.1,5.24 -0.6,10.62 -1.54,16.11 -10.3,52.77 -20.23,88.86 -30.35,141.68l-202.3 -0.16 0 28.13 -147.9 0 -58.8 88.07 -58.32 -88.07 -148.33 0 0.01 -28.13 -202.31 0.16c-10.08,-52.82 -20.05,-88.91 -30.34,-141.68 -0.94,-5.49 -1.45,-10.87 -1.54,-16.11 -0.44,-24.69 8.45,-44.85 22.86,-59.77 14.27,-14.76 33.89,-24.3 55.11,-27.94 5.72,-0.98 11.65,-1.54 17.69,-1.64l236.2 -0.03 -49.07 -356.75 -904.19 0c-5.22,-74.18 -18.5,-147.06 -18.5,-219.21 -0.26,-4.97 -0.35,-9.94 -0.26,-14.89 0.73,-41.63 14.32,-76.26 37.91,-101.07 23.63,-24.85 57.16,-39.75 97.75,-41.93 4.46,-0.24 9.11,-0.32 13.91,-0.24z" />

                    <path color={this.state.aircraftColors.wings} d="M79.81 737.13l1003.97 0 1003.96 0c2.26,-65.52 7.02,-131.94 6.79,-196.55 -0.12,-35.36 -28.93,-64.29 -64.28,-64.29l-946.47 0 -946.47 0c-35.36,0 -64.16,28.93 -64.29,64.29 -0.22,64.61 4.53,131.03 6.79,196.55z" />

                    <path color={this.state.aircraftColors.front} d="M1083.78 85.52l35.03 74.63c25.94,65.15 63.11,243.78 62.78,289.46l0 210.12c0.16,17.48 -1.86,45.3 -5.47,80.6 -0.27,2.71 -0.56,5.46 -0.85,8.26l-91.49 134.3 -91.43 -133.72c-0.19,-1.79 -0.39,-3.59 -0.57,-5.35 -3.83,-36.98 -5.99,-66.03 -5.82,-84.09l0 -210.12c-0.33,-45.68 36.84,-224.31 62.77,-289.46l35.05 -74.63zm0 797.37l0 -140.81 0 -656.56z" />
                    <path onClick={this.handleBackClick} color={this.state.aircraftColors.back} d="M1083.78 1425.95c-4.34,-33.99 -9.28,-70.8 -14.57,-109.29l-16.26 0 0 20.67 -3.34 0 0 8.65c0.07,0.2 0.1,0.41 0.1,0.64l0 10.41c0,1.13 -0.91,2.04 -2.03,2.04l-118.2 0c-1.12,0 -2.03,-0.91 -2.03,-2.04l0 -9.96 -207.76 0c-6.49,-27.03 -12.53,-94.83 -12.68,-128.66 -0.04,-7.19 5.88,-13.08 13.07,-13.08l333.57 0c-23.65,-167.24 -49.58,-345.3 -61.3,-456.16l91.43 133.72 91.49 -134.3c-11.7,110.83 -37.68,289.21 -61.37,456.74l333.57 0c7.19,0 13.1,5.89 13.08,13.08 -0.16,33.83 -6.19,101.63 -12.68,128.66l-207.76 0 0 9.96c0,1.13 -0.92,2.04 -2.04,2.04l-118.2 0c-1.12,0 -2.03,-0.91 -2.03,-2.04l0 -10.41c0,-0.23 0.03,-0.44 0.1,-0.64l0 -8.65 -3.34 0 0 -20.67 -16.26 0c-5.29,38.49 -10.22,75.3 -14.56,109.29z" />

                    <path color={this.state.aircraftColors.frontDetail} d="M1011.56 409.09c20.76,-140.05 45.74,-210.78 72.22,-256.44 26.47,45.66 51.45,116.39 72.2,256.44 -14.21,-2.68 -26.92,-4.38 -43.33,-5.2 -18.41,0 -36.82,0 -55.23,0 -15.73,0.49 -31.03,2.15 -45.86,5.2z" />
                    <polygon color={this.state.aircraftColors.propeller} points="1083.78,85.53 1108.69,138.38 1058.86,138.38 " />

                    <polygon color={this.state.aircraftColors.middle} points="1083.78,914.26 994.37,767.77 991.68,742.84 988.48,709.01 1083.78,859.28 1179.09,708.74 1176.07,740.86 1173.23,767.35 " />

                    <path color={this.state.aircraftColors.hoper} d="M1011.56 409.09c14.82,-3.05 30.13,-4.72 45.85,-5.2 18.42,0 36.83,0 55.25,0 16.41,0.81 29.12,2.52 43.32,5.2l6.12 44.24 0 20.52 0 171.73 -5.57 0c-4.08,-15.55 -16.12,-25.51 -33.99,-29.18 -12.84,-1.47 -25.77,-2.16 -38.76,-2.27l0 0c-12.74,-0.13 -25.63,0.43 -38.82,2.27 -18.9,3.82 -30.38,13.63 -33.95,29.18l-5.56 0 0 -171.16 0 -21.09 6.11 -44.24z" />

                    <path color={this.state.aircraftColors.hoperDetail} d="M1050.59 457.08l66.83 0c1.21,0 2.31,0.5 3.11,1.29 0.79,0.8 1.29,1.9 1.29,3.11l0 93.55c0,1.2 -0.5,2.3 -1.29,3.1 -0.8,0.8 -1.9,1.3 -3.11,1.3l-66.83 0c-1.21,0 -2.31,-0.5 -3.1,-1.3l-0.01 0c-0.79,-0.8 -1.29,-1.9 -1.29,-3.1l0 -93.55c0,-1.21 0.5,-2.31 1.29,-3.11 0.8,-0.79 1.9,-1.29 3.11,-1.29zm66.83 3.62l-66.83 0c-0.22,0 -0.41,0.09 -0.55,0.23 -0.14,0.14 -0.23,0.34 -0.23,0.55l0 93.55c0,0.21 0.09,0.41 0.23,0.55 0.14,0.14 0.33,0.22 0.55,0.22l66.83 0c0.21,0 0.41,-0.09 0.55,-0.23 0.14,-0.13 0.22,-0.33 0.22,-0.54l0 -93.55c0,-0.21 -0.08,-0.41 -0.22,-0.55 -0.14,-0.14 -0.34,-0.23 -0.55,-0.23z" />
                    <rect color={this.state.aircraftColors.hoperDetail} x="1052.3" y="467.95" width="8.38" height="79.93" />
                    <rect color={this.state.aircraftColors.hoperDetail} x="1036.91" y="467.95" width="6.34" height="79.93" />

                    <circle color={this.state.aircraftColors.hoperDetail} cx="1053.58" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1059.07" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1064.56" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1070.05" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1075.54" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1081.03" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1086.52" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1092.01" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1097.5" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1102.99" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1108.48" cy="463.93" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1113.97" cy="463.93" r="1.19" />

                    <circle color={this.state.aircraftColors.hoperDetail} cx="1053.58" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1059.07" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1064.56" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1070.05" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1075.54" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1081.03" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1086.52" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1092.01" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1097.5" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1102.99" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1108.48" cy="552.46" r="1.19" />
                    <circle color={this.state.aircraftColors.hoperDetail} cx="1113.97" cy="552.46" r="1.19" />

                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1055.24 679.17l-13.61 -53.16c-6.5,1.58 -12.08,4.8 -16.24,10.48 -4.53,6.18 -7.46,15.32 -8.22,28.44l26.21 31.9c0.41,-4 1.54,-7.45 3.16,-10.24 2.18,-3.73 5.26,-6.29 8.7,-7.42zm-10.53 -55.74l14.98 58.5 -1.94 0.33c-3.15,0.54 -6.06,2.7 -8.08,6.16 -1.94,3.32 -3.05,7.8 -2.82,13.21l0.24 5.4c-11.2,-13.63 -22.39,-27.27 -33.6,-40.89l0.04 -0.7c0.73,-14.26 3.93,-24.24 8.95,-31.09 5.11,-6.98 12.04,-10.67 20.13,-12.25l1.67 -0.33 0.43 1.66z" />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1063.79 680.41l-15.06 -60.21 70.75 0c-5.12,20.53 -10.25,41.06 -15.39,61.58l-39.96 0 -0.34 -1.37zm-10.42 -56.59l13.58 54.34 15.35 0 18.96 0 13.59 -54.34 -32.55 0 -28.93 0z" />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1109.02 680.03l14.91 -58.26 1.68 0.33c8.09,1.58 15.02,5.27 20.13,12.25 5.02,6.85 8.22,16.83 8.95,31.09l0.04 0.7 -33.6 40.89 0.23 -5.4c0.24,-5.41 -0.87,-9.89 -2.81,-13.21 -2.02,-3.46 -4.94,-5.62 -8.08,-6.16l-1.94 -0.33 0.49 -1.9zm17.56 -54.02l-13.6 53.16c3.44,1.13 6.51,3.69 8.7,7.42 1.62,2.79 2.75,6.24 3.16,10.24l26.21 -31.9c-0.76,-13.12 -3.69,-22.26 -8.22,-28.44 -4.16,-5.68 -9.74,-8.9 -16.25,-10.48z" />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1142.15 771.73l8.37 -88.79 -24.94 32.13 -2.27 65.54 18.84 -8.88zm12.55 -94.63l-9.15 97.03 -26.28 12.38c1.6,-22.64 1.21,-50.15 2.77,-72.79 13.48,-17.32 19.79,-25.48 33.25,-42.81l-0.59 6.19z" />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1026.63 771.73l-8.38 -88.79 24.95 32.13 2.26 65.54 -18.83 -8.88zm-12.56 -94.63l9.16 97.03 26.28 12.38c-1.6,-22.64 -1.22,-50.15 -2.78,-72.79 -13.47,-17.32 -19.78,-25.48 -33.24,-42.81l0.58 6.19z" />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} d="M1057.45 680.48l-14.49 -56.61c-15.32,3 -26.2,13.9 -27.63,41.66l29.72 36.18c-0.53,-12.11 5.36,-20.03 12.4,-21.23z" />
                    <polygon display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} points="1065.54,679.97 1051.05,622.01 1084.11,622.01 1117.17,622.01 1102.68,679.97 1084.11,679.97 " />
                    <path display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} d="M1110.77 680.48l14.49 -56.61c15.32,3 26.2,13.9 27.63,41.66l-29.72 36.18c0.53,-12.11 -5.37,-20.03 -12.4,-21.23z" />
                    <polygon display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} points="1143.85,772.93 1152.9,676.92 1123.81,714.39 1121.29,783.56 " />
                    <polygon display={(this.state.aircraftColors.windowsType == '1' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} points="1024.93,772.93 1015.87,676.92 1044.96,714.39 1047.48,783.56 " />

                    <path display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1044.24 706.82l-32.71 -39.55 0.02 -0.69c0.48,-12.89 4.21,-23.72 9.78,-31.53 6.07,-8.5 14.33,-13.47 23,-13.71 22.73,0 60.01,-2.65 80.87,-0.4 8.07,0.98 16.46,6.63 22.47,15.49 5.26,7.76 8.71,18.01 8.53,29.74l-0.01 0.63c-12.13,14.72 -24.22,29.48 -36.33,44.22l0.16 -5.29c0.18,-5.99 -1.25,-11.67 -3.86,-15.84 -2.37,-3.77 -5.69,-6.27 -9.63,-6.52l-47.75 -0.39c-4.39,0.03 -7.17,2.99 -8.86,7.06 -1.86,4.46 -2.47,10.2 -2.47,15.18l0.01 5.49 -3.22 -3.89zm-29.05 -40.8l28.79 34.81c0.3,-4.18 1.07,-8.52 2.6,-12.17 2.23,-5.35 6.02,-9.25 12.19,-9.29 0.03,-0.03 43.86,0.39 47.99,0.39 5.19,0.33 9.48,3.48 12.45,8.22 2.25,3.58 3.73,8.11 4.24,12.98l29.14 -35.47c0.05,-10.68 -3.13,-19.99 -7.91,-27.04 -5.39,-7.96 -12.8,-13.03 -19.85,-13.9l-80.4 0.4c-7.51,0.21 -14.75,4.62 -20.15,12.2 -5.09,7.13 -8.54,17.04 -9.09,28.87z" />
                    <path display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1148.13 746.94l5.19 -65.02 -30.19 35.86 -2.98 42.35 27.98 -13.19zm3.4 2.4l-35.42 16.69c1.6,-22.64 1.92,-26.96 3.49,-49.6 13.47,-17.31 23.24,-27.88 36.69,-45.21l-4.76 78.12z" />
                    <path display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor} d="M1019.72 746.94l-5.19 -65.02 30.19 35.86 2.98 42.35 -27.98 -13.19zm-3.4 2.4l35.42 16.69c-1.6,-22.64 -1.93,-26.96 -3.49,-49.6 -13.47,-17.31 -23.24,-27.88 -36.7,-45.21l4.77 78.12z" />
                    <path display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} d="M1045.64 705.67l-32.28 -39.03c0.95,-25.86 15.34,-43.06 31.02,-43.49l80.61 -0.41c14.29,1.72 29.79,19.3 29.4,43.4l-32.57 39.64c0.38,-12.38 -5.82,-23.61 -15.18,-24.22l-47.77 -0.39c-10.8,0 -13.31,14.09 -13.23,24.5z" />
                    <polygon display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} points="1149.83,748.14 1154.47,677.26 1121.36,717.11 1118.13,763.08 " />
                    <polygon display={(this.state.aircraftColors.windowsType == '2' || this.state.aircraftColors.windowsType == '3') && 'none'} color={this.state.aircraftColors.windowsColor2} points="1018.02,748.14 1013.38,677.26 1046.49,717.11 1049.72,763.08 " />

                    <path color={this.state.aircraftColors.wingsDetail} d="M2042.28 564.14c-0.91,-40.69 -3.41,-76.21 -13.01,-87.85l-52.01 0c6.43,3.66 10.08,38.6 12.38,88.76l1.24 80.15c0.17,33.64 -0.74,63.72 -4.7,91.93l51.39 0c5.74,-52.56 4.55,-79.94 4.71,-92.84l0 -80.15z" />
                    <path color={this.state.aircraftColors.wingsDetail} d="M125.37 564.14c0.91,-40.69 3.41,-76.21 13,-87.85l52.02 0c-6.43,3.66 -10.09,38.6 -12.39,88.76l-1.24 80.15c-0.16,33.64 0.75,63.72 4.71,91.93l-51.4 0c-5.74,-52.56 -4.54,-79.94 -4.7,-92.84l0 -80.15z" />

                    <rect color={this.state.aircraftColors.wingsDetail2} x="940.22" y="476.29" width="45.27" height="211.93" />
                    <rect color={this.state.aircraftColors.wingsDetail2} x="1182.06" y="476.29" width="45.27" height="211.93" />

                    <rect color={this.state.aircraftColors.wingsDetail3} x="1230.52" y="558.44" width="45.27" height="79.59" />
                    <rect color={this.state.aircraftColors.wingsDetail3} x="891.77" y="558.44" width="45.27" height="79.59" />

                    <path display={this.state.aircraftColors.tailType == '2' && 'none'} color={this.state.aircraftColors.tailColor} d="M1078.05 1350.01l5.73 75.94 5.72 -75.94 0 -163.93c-2.44,-2.73 -4.68,-4.2 -5.72,-4.08 -1.04,-0.12 -3.29,1.35 -5.73,4.08l0 163.93z" />
                    <path display={this.state.aircraftColors.tailType == '2' && 'none'} color={this.state.aircraftColors.tailColor} d="M1073.32 1191.54l4.73 -5.46 0 163.93 3.53 46.88 -6.42 -47.16 -1.84 -158.19zm20.91 0l-4.73 -5.46 0 163.93 -3.53 46.88 6.42 -47.16 1.84 -158.19z" />

                    <path display={this.state.aircraftColors.tailType == '1' && 'none'} color={this.state.aircraftColors.tailColor} d="M1076.96 1293.27l2.33 -108.35c-4.63,0.04 -16.67,-7.43 -22.33,-15.64l20 123.99z" />
                    <path display={this.state.aircraftColors.tailType == '1' && 'none'} color={this.state.aircraftColors.tailColor} d="M1090.63 1293.27l-2.53 -108.35c5.05,0.04 18.19,-7.43 24.37,-15.64l-21.84 123.99z" />

                    <path display={this.state.aircraftColors.tailType == '1' && 'none'} color={this.state.aircraftColors.tailColor2} d="M1056.45 1162.47l-1.81 -24.64c5.71,9.51 14.16,16.97 25.03,22.61l0.11 19.64c-8.86,-2.31 -18.22,-9.7 -23.33,-17.61z" />
                    <path display={this.state.aircraftColors.tailType == '1' && 'none'} color={this.state.aircraftColors.tailColor2} d="M1113.03 1162.47l1.97 -24.64c-6.23,9.51 -15.46,16.97 -27.33,22.61l-0.12 19.64c9.68,-2.31 19.89,-9.7 25.48,-17.61z" />

                    <path display={this.state.aircraftColors.special != 'travicar' && 'none'} color={this.state.aircraftColors.specialColor} d="M254.85 715.1l-76.96 0 0 -167.39 -58.67 0 0 -43.4 193.86 0 0 43.4 -58.23 0 0 167.39zm196.79 -210.79c25.21,0 46.16,2.32 62.93,6.94 16.79,4.58 29.31,11.51 37.58,20.67 8.35,9.2 12.45,20.76 12.45,34.68 0,8.17 -1.59,15.75 -4.86,22.64 -3.27,6.94 -8.19,13.23 -14.72,18.89 -6.46,5.71 -14.73,10.73 -24.68,15.16l67.87 91.81 -85.16 0 -50.94 -79.12 -10.02 0 0 79.12 -77.42 0 0 -210.79 86.97 0zm-0.91 41.97l-8.64 0 0 50.78 8.2 0c11.61,0 20.27,-2.31 26.04,-6.94 5.77,-4.62 8.71,-11.56 8.71,-20.91 0,-7.72 -2.88,-13.43 -8.57,-17.27 -5.76,-3.79 -14.27,-5.66 -25.74,-5.66zm330.78 168.82l-12.31 -41.04 -70.21 0 -12.3 41.04 -83.8 0 79.17 -210.79 102.1 0 80.24 210.79 -82.89 0zm-24.3 -84.14l-13.13 -47.18c-1.45,-5.27 -2.81,-10.43 -4.1,-15.45 -1.22,-4.97 -2.35,-9.8 -3.33,-14.32 -0.91,-4.58 -1.83,-8.86 -2.52,-12.79 -0.6,3.73 -1.43,7.87 -2.34,12.39 -0.99,4.53 -2.13,9.25 -3.51,14.22 -1.28,4.97 -2.73,10.09 -4.16,15.36l-13.82 47.77 46.91 0zm379.12 -126.65l-82.89 210.79 -90.09 0 -82.06 -210.79 81.15 0 32.7 103.97c1.53,4.58 3.2,10.28 5.02,16.97 1.82,6.75 3.5,13.44 5.01,20.08 1.44,6.64 2.5,12.05 3.12,16.29 0.91,-4.24 2.11,-9.65 3.64,-16.24 1.59,-6.59 3.25,-13.19 5.15,-19.88 1.84,-6.69 3.5,-12.35 4.94,-16.93l33.17 -104.26 81.14 0zm43.77 210.79l0 -210.79 77.43 0 0 210.79 -77.43 0zm266.92 -170.93c-7.59,0 -14.35,1.52 -20.27,4.57 -5.91,3.05 -10.85,7.43 -14.87,13.19 -4.03,5.71 -7.07,12.69 -9.1,20.91 -2.06,8.22 -3.12,17.47 -3.12,27.8 0,14.32 1.9,26.23 5.69,35.77 3.72,9.6 9.41,16.73 17,21.45 7.52,4.73 17,7.09 28.47,7.09 10.47,0 20.64,-1.28 30.36,-3.89 9.72,-2.6 19.43,-5.7 29.23,-9.35l0 44.98c-10.4,3.93 -21.64,6.84 -33.71,8.75 -12.06,1.92 -24.9,2.91 -38.33,2.91 -25.81,0 -47.6,-4.14 -65.28,-12.45 -17.77,-8.27 -31.13,-20.47 -40.23,-36.56 -9.18,-16.09 -13.75,-35.77 -13.75,-58.99 0,-16.29 2.81,-31.1 8.37,-44.53 5.61,-13.39 13.57,-24.9 24.12,-34.54 10.56,-9.65 23.24,-17.08 38.19,-22.34 14.88,-5.27 31.73,-7.87 50.55,-7.87 14.42,0 28.23,1.18 41.45,3.59 13.29,2.41 26.49,6.15 39.47,11.26l-20.41 41.24c-8.58,-3.94 -17.31,-7.09 -26.05,-9.45 -8.73,-2.36 -17.98,-3.54 -27.78,-3.54zm280.68 170.93l-12.31 -41.04 -70.21 0 -12.29 41.04 -83.8 0 79.17 -210.79 102.1 0 80.23 210.79 -82.89 0zm-24.3 -84.14l-13.12 -47.18c-1.45,-5.27 -2.81,-10.43 -4.11,-15.45 -1.22,-4.97 -2.34,-9.8 -3.33,-14.32 -0.91,-4.58 -1.82,-8.86 -2.51,-12.79 -0.61,3.73 -1.44,7.87 -2.35,12.39 -0.99,4.53 -2.13,9.25 -3.5,14.22 -1.28,4.97 -2.73,10.09 -4.17,15.36l-13.82 47.77 46.91 0zm237.94 -126.65c25.21,0 46.16,2.32 62.93,6.94 16.78,4.58 29.31,11.51 37.58,20.67 8.34,9.2 12.45,20.76 12.45,34.68 0,8.17 -1.59,15.75 -4.86,22.64 -3.27,6.94 -8.2,13.23 -14.72,18.89 -6.47,5.71 -14.73,10.73 -24.69,15.16l67.87 91.81 -85.16 0 -50.94 -79.12 -10.01 0 0 79.12 -77.43 0 0 -210.79 86.98 0zm-0.91 41.97l-8.64 0 0 50.78 8.19 0c11.62,0 20.27,-2.31 26.04,-6.94 5.77,-4.62 8.72,-11.56 8.72,-20.91 0,-7.72 -2.89,-13.43 -8.58,-17.27 -5.75,-3.79 -14.27,-5.66 -25.73,-5.66z" />

                  </SvgIcon>
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.CORPO_SUPERIOR}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('front')} value={this.state.aircraftColors.front} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.CORPO_INFERIOR}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('back')} value={this.state.aircraftColors.back} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.ASAS}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('wings')} value={this.state.aircraftColors.wings} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.ASAS_PONTAS}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('wingsDetail')} value={this.state.aircraftColors.wingsDetail} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.ASAS_INTERNOS}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('wingsDetail2')} value={this.state.aircraftColors.wingsDetail2} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.ASAS_INTERNO_2}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('wingsDetail3')} value={this.state.aircraftColors.wingsDetail3} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.BICO}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('propeller')} value={this.state.aircraftColors.propeller} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.DETALHE_FRENTE}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('frontDetail')} value={this.state.aircraftColors.frontDetail} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.HOPER}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('hoper')} value={this.state.aircraftColors.hoper} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.DETALHE_HOPERT}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('hoperDetail')} value={this.state.aircraftColors.hoperDetail} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.VIDROS}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('windowsColor2')} value={this.state.aircraftColors.windowsColor2} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.CONTORNO_VIDROS}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('windowsColor')} value={this.state.aircraftColors.windowsColor} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.DETALHE_CENTRO}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('middle')} value={this.state.aircraftColors.middle} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.CAUDA}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('tailColor')} value={this.state.aircraftColors.tailColor} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.DETALHE_CAUDA}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('tailColor2')} value={this.state.aircraftColors.tailColor2} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.FUNDO}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('background')} value={this.state.aircraftColors.background} />
                </FormControl>
                <FormControl style={{ marginRight: '10px', marginLeft: '10px' }}>
                  <InputLabel>{res.BORDA}</InputLabel>
                  <ColorPicker onChange={this.handleColorChange('border')} value={this.state.aircraftColors.border} />
                </FormControl>
                <FormControl
                  style={{ padding: ".4rem 0 .4rem 0", paddingLeft: '55px' }}
                  fullWidth
                  component="fieldset">
                  <div className='titleTextRel'>{res.EXIBIR_FUNDO}</div>
                  <RadioGroup row id="tipo_janela" aria-label="janela" value={this.state.aircraftColors.showBackground} onChange={this.handleColorChange('showBackground')}>
                    <FormControlLabel value="1" control={<Radio color="primary" />} label={res.SIM} />
                    <FormControlLabel value="2" control={<Radio color="primary" />} label={res.NAO} />
                  </RadioGroup>
                </FormControl>
                <FormControl
                  style={{ padding: ".4rem 0 .4rem 0", paddingLeft: '55px' }}
                  fullWidth
                  component="fieldset">
                  <div className='titleTextRel'>{res.TIPO_JANELA}</div>
                  <RadioGroup row id="tipo_janela" aria-label="janela" value={this.state.aircraftColors.windowsType} onChange={this.handleColorChange('windowsType')}>
                    <FormControlLabel value="1" control={<Radio color="primary" />} label={'1'} />
                    <FormControlLabel value="2" control={<Radio color="primary" />} label={'2'} />
                    <FormControlLabel value="3" control={<Radio color="primary" />} label={res.SEM_JANELA} />
                  </RadioGroup>
                </FormControl>
                <FormControl
                  style={{ padding: ".4rem 0 .4rem 0", paddingLeft: '55px' }}
                  fullWidth
                  component="fieldset">
                  <div className='titleTextRel'>{res.TIPO_CAUDA}</div>
                  <RadioGroup row id="tipo_cauda" aria-label="cauda" value={this.state.aircraftColors.tailType} onChange={this.handleColorChange('tailType')}>
                    <FormControlLabel value="1" control={<Radio color="primary" />} label={'1'} />
                    <FormControlLabel value="2" control={<Radio color="primary" />} label={'2'} />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
          </div>
          <div style={{ display: this.state.stage === '3' ? 'block' : 'none' }}>
            <div className="form-group notTooBig">
              {[
                { id: 'application_speed', label: Tools.replaceString(res._VELOCIDADE_APLICACAO, Units.getSpeedUnit(res)) },
                { id: 'travel_speed', label: Tools.replaceString(res._VELOCIDADE_TRANSLADO, Units.getSpeedUnit(res)) },
                { id: 'balloon_speed', label: Tools.replaceString(res._VELOCIDADE_MEDIA_BALAO, Units.getSpeedUnit(res)) },
                { id: 'flow_rate', label: Tools.replaceString(res._FLUXO_APLICACAO, Units.getFlowUnit(res, 'L')) },
                { id: 'hopper_load', label: Tools.replaceString(res._CARGO_HOPPER, Units.getVolumeUnit(res, 'L')) },
                { id: 'swath_width', label: Tools.replaceString(res._LARGURA_FAIXA, Units.getLengthUnit(res)) },
                { id: 'flight_height', label: Tools.replaceString(res._ALTURA_VOO, Units.getLengthUnit(res)) },
                { id: 'balloon_width', label: Tools.replaceString(res._TAMANHO_BALAO, Units.getLengthUnit(res)) },
                { id: 'balloon_length', label: Tools.replaceString(res._DISTANCIA_BALAO, Units.getLengthUnit(res)) }
              ].map((item) => {
                return (
                  <TextField
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    value={this.state[item.id]}
                    onChange={this.handleNumberChange(item.id)}
                    margin="normal"
                    fullWidth
                    inputProps={{
                      inputMode: 'decimal'
                    }}
                  />
                );
              })}
            </div>
          </div>
          <div style={{ display: this.state.stage === '4' ? 'block' : 'none' }}>
            <Button variant="contained" color="primary" onClick={() => { this.setState({ itensAutoConfig: [this.newAutoConfig()].concat(this.state.itensAutoConfig) }) }}>
              {res.NOVA_REGRA}
            </Button>
            {this.state.itensAutoConfig.map(item => (this.autoConfig(item)))}
          </div>
        </div>
      </div>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">
      <TextFields1 link={link} id={id} res={res} />
    </div>)
}

export default Box;